<template>
  <div>

    <section class="wrapper bg-soft-primary">
      <div class="container pt-10 pb-12 pt-md-14 pb-md-16 text-center">
        <div class="row">
          <div class="col-md-9 col-lg-7 col-xl-5 mx-auto">
            <h1 class="display-1 mb-3">Créer un shop</h1>
            <p class="lead px-xxl-10">Tout shop créé sera automatiquement disponible au niveau du chatbot.</p>
          </div>
          <!-- /column -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container -->
    </section>
    <section class="wrapper bg-light">
  <div class="container py-10 py-md-16">
    <div class="row">
      <div class="col-xl-10 mx-auto">
        <div class="row gy-10 gx-lg-8 gx-xl-12">
          <div class="col-lg-8">
            <form class="contact-form needs-validation" method="post" action="./assets/php/contact.php" novalidate>
              <div class="messages"></div>
              <div class="row gx-4">
                <div class="col-md-6">
<picture-input
      ref="pictureInput"
      width="600"
      height="600"
      margin="16"
      accept="image/jpeg,image/png"
      size="10"
      button-class="btn"
      :custom-strings="{
        upload: '<h1>Bummer!</h1>',
        drag: 'Uploader le logo'
      }" id="profilpage"
      @change="onChange">
    </picture-input>
                </div><div class="col-md-12"></div>
                <div class="col-md-6">
                  <div class="form-floating mb-2">
                    <input id="form_name"  v-model="shopinput.titleshop" type="text" name="name" class="form-control" placeholder="Jane" required>
                    <label for="form_name">Nom de la boutique *</label>
<div class="valid-feedback">
                      Looks good!
                    </div>
                    <div class="invalid-feedback">
                      Please select a department.
                    </div>
                  </div>
                </div>
                <!-- /column -->
                <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <input id="form_lastname" v-model="shopinput.subdomain" type="text" name="surname" class="form-control" placeholder="Doe" required>
                    <label for="form_lastname">Sous domaine *</label>
<div class="valid-feedback">
                      Looks good!
                    </div>
                    <div class="invalid-feedback">
                      Please select a department.
                    </div>
                  </div>
                </div>
                <!-- /column -->
                <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <input id="form_email" type="email" v-model="shopinput.email" name="email" class="form-control" placeholder="jane.doe@example.com" required>
                    <label for="form_email">Email *</label>
<div class="valid-feedback">
                      Looks good!
                    </div>
                    <div class="invalid-feedback">
                      Please select a department.
                    </div>
                  </div>
                </div>



                <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <input id="form_email" type="text"  v-model="shopinput.tel" name="tel" class="form-control" placeholder="+22177654554" required>
                    <label for="form_email">Tel *</label>
                  <div class="valid-feedback">
                      Looks good!
                    </div>
                    <div class="invalid-feedback">
                      Please select a department.
                    </div>
                  </div>
                </div>

                 <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <input id="form_email" type="text"  v-model="shopinput.location" name="localisation" class="form-control" placeholder="https://maps.app.goo.gl/wMbNNbebViw9iJEJ7" required>
                    <label for="form_email">localisation google map *</label>
                  <div class="valid-feedback">
                      Looks good!
                    </div>
                    <div class="invalid-feedback">
                      Please select a department.
                    </div>
                  </div>
                </div>

                 <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <input id="form_email" type="text"  v-model="shopinput.horaires" name="houropenning" class="form-control" placeholder="8h00-22h00" required>
                    <label for="form_email">Horaires d'ouverture</label>
                 <div class="valid-feedback">
                      Looks good!
                    </div>
                    <div class="invalid-feedback">
                      Please select a department.
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-floating mb-4">
                    <input id="dayopenning" type="text"  v-model="shopinput.jours" name="dayopenning" class="form-control" placeholder="du Lundi au Samedi" required>
                    <label for="dayopenning">jours d'ouverture</label>
                 <div class="valid-feedback">
                      Looks good!
                    </div>
                    <div class="invalid-feedback">
                      Please select a department.
                    </div>
                  </div>
                </div>

                <!-- /column -->
                <div class="col-md-6">
                  <div class="form-select-wrapper">
                    <select class="form-select" id="form-select" required v-model="shopinput.typeshop">
                      <option selected disabled value="">type de kiosk</option>
                      <option v-for="typeshop in typesshop">  {{typeshop}} </option>
                    </select>
                    <div class="valid-feedback">
                      Looks good!
                    </div>
                    <div class="invalid-feedback">
                      Please select a department.
                    </div>
                  </div>
                </div>
                <!-- /column -->





                <!-- /column -->
                <div class="col-12">
                  <div class="form-floating mb-4">
                    <textarea id="form_message"  v-model="shopinput.descriptionshop" name="message" class="form-control" placeholder="Your message" style="height: 150px" required></textarea>
                    <label for="form_message">Description de la boutique *</label>
                    <div class="valid-feedback">
                      Looks good!
                    </div>
                  </div>
                </div>
                <!-- /column -->
                <div class="col-12">
                  <div class="form-check mb-4">
                    <input class="form-check-input" type="checkbox" v-model="shopinput.agreement" value="1" id="invalidCheck" required>
                    <label class="form-check-label" for="invalidCheck">
                      I agree to <a href="#" class="hover">terms and policy</a>.
                    </label>
                    <div class="invalid-feedback">
                      You must agree before submitting.
                    </div>
                  </div>
                </div>
                <!-- /column -->
                <div class="col-12">
                  <input type="submit" @click.prevent="createShop" class="btn btn-primary rounded-pill btn-send mb-3" value="Send message">
                  <p class="text-muted"><strong>*</strong> These fields are required.</p>
                </div>
                <!-- /column -->
              </div>
              <!-- /.row -->
            </form>
            <!-- /form -->
          </div>
          <!--/column -->
          <div class="col-lg-4">
            <div class="d-flex flex-row">
              <div>
                <div class="icon text-primary fs-28 me-4 mt-n1"> <i class="uil uil-location-pin-alt"></i> </div>
              </div>
              <div>
                <h5 class="mb-1">Address</h5>
                <address>Moonshine St. 14/05 Light City, London, United Kingdom</address>
              </div>
            </div>
            <div class="d-flex flex-row">
              <div>
                <div class="icon text-primary fs-28 me-4 mt-n1"> <i class="uil uil-phone-volume"></i> </div>
              </div>
              <div>
                <h5 class="mb-1">Phone</h5>
                <p>00 (123) 456 78 90 <br class="d-none d-md-block" />00 (987) 654 32 10</p>
              </div>
            </div>
            <div class="d-flex flex-row">
              <div>
                <div class="icon text-primary fs-28 me-4 mt-n1"> <i class="uil uil-envelope"></i> </div>
              </div>
              <div>
                <h5 class="mb-1">E-mail</h5>
                <p class="mb-0"><a href="mailto:sandbox@email.com" class="text-body">sandbox@email.com</a></p>
                <p><a href="mailto:help@sandbox.com" class="text-body">help@sandbox.com</a></p>
              </div>
            </div>
          </div>
          <!--/column -->
        </div>
        <!--/.row -->
      </div>
      <!-- /column -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container -->
</section>
<!-- /section -->
  </div>
</template>

<style scoped>

   @import url("https://mojay.pro/assets/css/style.css");

</style>

<script>


import PictureInput from "vue-picture-input";
import axios from "axios";

export default {
  title: "CreateShop",
  props: {},
  computed: {
    google: function () {},
  },
  data() {
    return {
      modoou: false,
      typesshop: ["Cosmétique", "Alimentaire", "Shopping","Ecommerce","Autre"],
      shopinput: {
        titleshop: "",
        typeshop: "",
        email: "",
        tel: "",
        location:"",
        horaires:"",
        jours:"",
        subdomain: "",
        descriptionshop: "",
        Logobusiness: "",
        agreement:""
      },
      redirect: "https://kiosk.ojay.delivery/test",
      errorHtml: "",
      shops: []
    };
  },
  components: {
    PictureInput,
  },
  mounted() {
    this.placeHolder();
    this.getListShops();
     this.importjs('https://mojay.pro/assets/js/plugins.js');
     this.importjs('https://mojay.pro/assets/js/theme.js');
  },
  watch: {},

  methods: {
    previousPage() {
      console.log('previousPage ::: ')
      this.$router.push({
        name: "modalhome"
      });
    },
    gotoBlock(link){
       this.$router.push({
          name: 'settingshop',
         params: {
              idshop: link
          }
       });
    },
    importjs(link){

        let themejs = document.createElement('script')
        themejs.setAttribute('src', link)
        document.head.appendChild(themejs)
    },

    placeHolder() {
      this.shopinput.titleshop = "titleshop";
      this.shopinput.typeshop = "typeshop";
      this.shopinput.email = "dieyebow@gmail.com";
      this.shopinput.tel = "781528375";
      this.shopinput.subdomain = "subdomain";
      this.shopinput.descriptionshop =
        "In a land of myth, on a time of magic the destiny of a great a kingdom";
      this.shopinput.Logobusiness = "";
    },
    getListShops(){

      let fullpath = this.redirect + '/get/infos/shops';
      this.$http.get(fullpath).then(
        function(response) {
          console.log("response=>", response);
          if( response.data.shops ){
            this.shops = response.data.shops;
          }
        },
        function(error) {

        }
      );


    },

    getSimplifyblock(block) {},

    replacer(match, pIndent, pKey, pVal, pEnd) {
      var key = `<span class="jsonkey" @click.prevent="clickey()" style="color: #ffc600;font-weight:bold;font-size:17px">`;
      var val = `<span class="json-value">`;
      var str = `<span class="json-string">`;

      var r = pIndent || "";
      if (pKey) r = r + key + pKey.replace(/[": ]/g, "") + "</span>: ";
      if (pVal) r = r + (pVal[0] == '"' ? str : val) + pVal + "</span>";

      //console.log('the finale r ==> ', r + (pEnd || ''));
      return r + (pEnd || "");
    },

    prettyPrint(obj) {
      var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/gm;
      return JSON.stringify(obj, null, 3)
        .replace(/&/g, "&amp;")
        .replace(/\\"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(jsonLine, this.replacer);
    },

    createShop() {
      console.log("createShop");
      console.table(this.shopinput);
      let Oldthis = this;
      let formData = new FormData();

      _.forEach(Oldthis.shopinput, function (value, key) {
        if (key !== "Logobusiness") {
          formData.append(key, value);
          console.log(value);
        } else {
          formData.append(
            "Logobusiness",
            document.getElementById("profilpage").files[0]
          );
        }
      });

      let path_order = this.redirect + "/create/shop";

      /**
       * this.$http.post( path_order, {shop:this.shopinput },{})
       */
      console.log('formData ::>',formData);
      //return true;
      axios
        .post(path_order, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
          console.log("postReservation ==>", response.data);
          //this.errorHtml = this.prettyPrint(response.data);
          if(response.data.status){
              console.log('condition bien vérifié ==>',response.data.shop.idshop);
              Oldthis.$router.push({
                name: 'settingshop',
                params: {
                    idshop: response.data.shop.idshop
                }
            });
          }
        })
        .catch((error) => {

             this.errorHtml = error.body;

        });
    },
    onChange(image) {
      console.log("New picture selected!");
      if (image) {
        console.log("Picture loaded.");
        this.shopinput.Logobusiness = image;
      } else {
        console.log("FileReader API not supported: use the <form>, Luke!");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CreateShop.vue